import { render } from "./KamranGallerySingle.vue?vue&type=template&id=8b74d994&scoped=true"
import script from "./KamranGallerySingle.vue?vue&type=script&lang=js"
export * from "./KamranGallerySingle.vue?vue&type=script&lang=js"

import "./KamranGallerySingle.vue?vue&type=style&index=0&id=8b74d994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b74d994"]])

export default __exports__